/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */ export var styles = ['[_nghost-%COMP%]{pointer-events:none}.mat-tooltip[_ngcontent-%COMP%]{color:#fff;padding:6px 8px;border-radius:2px;font-family:Roboto,"Helvetica Neue",sans-serif;font-size:10px;margin:14px;max-width:250px}@media screen and (-ms-high-contrast:active){.mat-tooltip[_ngcontent-%COMP%]{outline:solid 1px}}'];
//# sourceMappingURL=tooltip.css.shim.ngstyle.js.map